// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"d8cf4fa3","261":"d8cf4fa3","674":"5e6ebbc7"}[chunkId] + ".chunk.css";
};